<template>
  <v-row v-if="!isLoading">
    <h1>Driver Dashboard</h1>
  </v-row>
</template>

<script>
import auth from '@/services/AuthService';

export default {
  data() {
    return {
      mode: null,
      isLoading: false,
    };
  },
  mounted() {
    this.mode = auth.getMode();
  },
};
</script>

<style lang="scss">
.v-skeleton-loader__image {
  height: 400px !important;
}
</style>
